import React from "react";
import { Link } from "react-router-dom";
//import { useRouteError } from "react-router-dom";

const Error = () => {
  return (
    <div>
      <h1>Page not found</h1>
      <Link to="/">Back to home page</Link>
    </div>
  );
};

export default Error;

// const errorPage = () => {
//   // const error = useRouteError();
//   // console.error(error);

//   return (
//     // <div id="error-page">
//     //   <h1>Oops!</h1>
//     //   <p>Sorry, an unexpected error has occurred.</p>
//     //   <p>
//     //     <i>{error.statusText || error.message}</i>
//     //   </p>
//     // </div>
//     <div>error occured</div>
//   );
// };

// export default errorPage;
